export enum InviteUserType {
    InviteUser = 0,
    InviteSelf = 1
}
